import React from "react";
import Img from "gatsby-image";


import usePost from "../../hooks/usePost";
import authors from "../../authors.json";
import NotByAI from "./NotByAI"

const containerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
};

function PostAuthor() {
  const { authorImage, author } = usePost();
  const { name, role } = authors[author];

  return (
    <div style={containerStyle}>
      <div className="post__author">
        <Img
          className="post__author__image"
          imgStyle={{ borderRadius: "50%" }}
          fluid={authorImage.childImageSharp.fluid}
          alt={name}
        />
        <div>
          <div className="post__author__name">{name}</div>
          <small className="post__author__role">{role}</small>
        </div>
      </div>
      <NotByAI/>
    </div>
  );
}

export default PostAuthor;
